import React, { useEffect } from "react";
import "./Home.css";
import WOW from "wowjs";

const Home = () => {
  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  return (
    <div className="parallax-content baner-content">
      <div className="bg-overlay"></div>
      <div className="container" style={{ zIndex: 1 }} data-wow-delay="2s">
        <div className="text-content">
          <h2 className="wow fadeInUp">
            <em>P.J</em> <span className="wow fadeInRight">DIESEL</span> <br />
            Specialists
          </h2>
          <p className="wow fadeInLeft">
            P.J DIESEL SPECIALISTS <br/> Specialists with a distinct love and passion
            for diesel mechanics.
          </p>
          <div className="primary-white-button">
            <button className="btn btn-outline-info wow tada">Let's Go!</button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Home;
